import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myHrPageWidthState = atom({
  key: "myHrPageWidthState",
  default: 0,
  effects_UNSTABLE: [ocPersistAtom],
});
